import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import React from "react";
import { Link } from "react-router-dom";
import { cardStyles, colorPallete, textStyles } from "../styles";
import StarIcon from '@material-ui/icons/Star';

export const TestTableCard = props => {
    const cards = cardStyles();
    const textStyle = textStyles();
    const colors = colorPallete();
    const classes = props.className || null;

    const determineCards = props => {
        if (props.useravailable == 1) {
            let obLink = {
                pathname : props.openpercentage < 100 ? '/questionScreen' : '/testResultScreen',
                testYear : props.testYear,
                gameMode : 1
            }

            let cbLink = {
                pathname : props.closedpercentage < 100 ? '/questionScreen' : '/testResultScreen',
                testYear : props.testYear,
                gameMode : 2
            }

            if (props.openpercentage >= 100) {
                obLink.deckID = 0;
            }

            if (props.closedpercentage >= 100) {
                cbLink.deckID = 0;
            }
            
            return (
                <>
                    <Grid item xs={4}>
                        <Grid container>
                            <div style={{ width: "100%" }}>
                                <div>
                                    <Link
                                        to={obLink}
                                    >
                                        <Grid item xs={12}>
                                            <Typography
                                                className={clsx(
                                                    textStyle.testCardText,
                                                    colors.lightBlueText
                                                )}
                                            >
                                                Open Book
                                                <span className="show-lg"> ({props.openpercentage}%)</span>
                                            </Typography>
                                        </Grid>
                                    </Link>
                                </div>
                                {/*//TODO pass open vs. closed book props & year information down */}
                                <Grid item xs={12}>
                                    <Typography
                                        className={clsx(
                                            textStyle.testCardText,
                                            textStyle.italics,
                                            colors.lightBlueText
                                        )}
                                    >
                                        {props.openProgress || "RESUME"}
                                    </Typography>
                                </Grid>
                            </div>
                        </Grid>
                    </Grid>
                    <div
                        style={{
                            borderLeft: "1px solid rgba(120, 124, 127, 1)",
                            marginRight: "10px",
                            marginLeft: "10px",
                            height: "85%",
                            marginTop: ".2em"
                        }}
                    ></div>
                    <Grid item xs={4}>
                        <Grid container>
                            <div style={{ width: "100%" }}>
                                <div>
                                    <Link
                                        to={cbLink}
                                    >
                                        <Grid item xs={12}>
                                            <Typography
                                                className={clsx(
                                                    textStyle.testCardText,
                                                    colors.lightBlueText
                                                )}
                                            >
                                                Closed Book
                                                <span className="show-lg"> ({props.closedpercentage}%)</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography
                                                className={clsx(
                                                    textStyle.testCardText,
                                                    textStyle.italics,
                                                    colors.lightBlueText
                                                )}
                                            >
                                                {props.closedProgress || "BEGIN"}
                                            </Typography>
                                        </Grid>
                                    </Link>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </>
            );
        } else {
            return (
                <Grid className={cards.testCardTextContainer} item xs={9}>
                    <Typography
                        className={clsx(textStyle.testCardYearText, colors.darkBlueText)}
                    >
                        Purchase this year online
                    </Typography>
                </Grid>
            );
        }
    };

    return (
        <Container
            disableGutters={props.disableGutters || false}
            fixed={props.fixed || false}
            maxWidth={props.maxWidth || "xs"}
            className={clsx(cards.testCardContainer, colors.lightBlueCard, classes)}
        >
            <Grid direction="row" container className={cards.testCardRowContainer}>
                <Grid className={cards.testCardTextContainer} item xs={3}>
                    <Typography
                        className={clsx(
                            textStyle.testCardYearText,
                            colors.darkBlueText,
                            textStyle.bold
                        )}
                    >
                        {props.testYear || "2020"}
                        {/* <>
                            {
                                props.openProgress.toLowerCase() === 'details' || 
                                props.closedProgress.toLowerCase() === 'details'
                                ? (
                                    <sup style={{position: "relative", top: "-8px"}}>
                                        <StarIcon style={{
                                            fontSize: "0.667em",
                                            color: "#00567a",
                                        }} />
                                    </sup>
                                ) : null
                            }                            
                        </> */}
                    </Typography>
                </Grid>
                {determineCards(props)}
            </Grid>
        </Container>
    );
};
